import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "color", "bg", "theme", "title", "svgStyle"];
import React from "react";
import { withTheme } from "styled-components";
import Box from "../Box";
var EllipsisIcon = withTheme(function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? "18px" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "18px" : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "ctrl" : _ref$color,
      _ref$bg = _ref.bg,
      bg = _ref$bg === void 0 ? "ctrlBg" : _ref$bg,
      theme = _ref.theme,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Icons/Ellipsis' : _ref$title,
      svgStyle = _ref.svgStyle,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    mt: "1px"
  }, props), /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 18 18",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: svgStyle
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: theme.colors[bg] || bg,
    d: "M8.99442777,18 C13.9096025,18 18,13.918215 18,9 C18,4.08178021 13.898458,0 8.9832833,0 C4.07925777,0 0,4.08178021 0,9 C0,13.918215 4.09040303,18 8.99442777,18 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: theme.colors[color] || color,
    d: "M4.5027877,7.61709595 C5.23839105,7.61709595 5.88483079,8.27508992 5.88483079,9.01115137 C5.88483079,9.75836418 5.23839105,10.3940507 4.5027877,10.3940507 C3.74489225,10.3940507 3.12074381,9.75836418 3.12074381,9.01115137 C3.12074381,8.27508992 3.74489225,7.61709595 4.5027877,7.61709595 Z M8.9832833,7.61709595 C9.73003349,7.61709595 10.3653311,8.27508992 10.3653311,9.01115137 C10.3653311,9.75836418 9.73003349,10.3940507 8.9832833,10.3940507 C8.24767758,10.3940507 7.61238546,9.75836418 7.61238546,9.01115137 C7.61238546,8.27508992 8.24767758,7.61709595 8.9832833,7.61709595 Z M13.4749289,7.61709595 C14.2328236,7.61709595 14.8569688,8.27508992 14.8569688,9.01115137 C14.8569688,9.75836418 14.2328236,10.3940507 13.4749289,10.3940507 C12.7281787,10.3940507 12.0928811,9.75836418 12.0928811,9.01115137 C12.0928811,8.27508992 12.7281787,7.61709595 13.4749289,7.61709595 Z",
    fillRule: "nonzero"
  }))));
});
export default EllipsisIcon;